module.exports = __webpack_public_path__ + "static/media/vectuel.364a11e8.svg";